import { LoadingTypes } from '../constants/loadingConstants';

const loadingStart = (key) => ({
    type: LoadingTypes.LOADING_START,
    key, 
});

const loadingEnd = (key) => ({
    type: LoadingTypes.LOADING_END,
    key
});

const handleError = (error) => ({
    type: LoadingTypes.HANDLE_ERROR,
    error
});

const showError = (error) => ({
    type: LoadingTypes.SHOW_ERROR,
    error
});

const setConnectionStatus = (status) => ({
    type: LoadingTypes.SET_CONNECTION_STATUS,
    status
});

const showBugReport = (show) => ({
    type: LoadingTypes.SET_BUGREPORT_STATUS,
    show
});

export default {
    loadingStart,
    loadingEnd,
    handleError,
    setConnectionStatus,
    showError,
    showBugReport
};